import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

interface TokenDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (token: string) => Promise<void>;
  onResendToken: () => void;
}

export function TokenDialog({ open, onClose, onSubmit, onResendToken }: TokenDialogProps) {
  const [token, setToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!token.trim()) {
      toast.error("Por favor, insira o token");
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(token);
      setToken('');
    } catch (error) {
      console.error('Erro ao validar token:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Token de Acesso</DialogTitle>
          <DialogDescription>
            Digite o token recebido no seu WhatsApp.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Input
            type="text"
            placeholder="Digite o token..."
            value={token}
            onChange={(e) => setToken(e.target.value)}
            maxLength={6}
            className="col-span-3"
          />
        </div>
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onResendToken}
            disabled={isSubmitting}
          >
            Reenviar Token
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            Validar Token
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
} 